import React, { useState, useEffect } from "react";
import { Modal, Box } from "@mui/material";
import { fetchComments, addComment, deleteComment } from "../../api/commentApi";
import { format } from "date-fns";
import "./commentSection.scss";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxHeight: "80vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "1px solid #ccc",
  boxShadow: 24,
  p: 4,
};

const CommentSection = ({ submissionId }) => {
  const [open, setOpen] = useState(false);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  const senderId = localStorage.getItem("userId");
  const currentUsername = localStorage.getItem("username");
  const lastComment = comments.length > 0 ? comments[comments.length - 1] : null;

  const loadComments = async () => {
    try {
      const data = await fetchComments(submissionId);
      setComments(data);
    } catch (err) {
      console.error("Error loading comments:", err);
    }
  };

  useEffect(() => {
    loadComments(); 
  }, []);
  

  const handleAdd = async () => {
    if (!newComment.trim()) return;
    try {
      await addComment(submissionId, senderId, newComment);
      setNewComment("");
      loadComments();
    } catch (err) {
      console.error("Error adding comment:", err);
    }
  };

  const handleDelete = async (commentId) => {
    try {
      await deleteComment(commentId);
      loadComments();
    } catch (err) {
      console.error("Error deleting comment:", err);
    }
  };

  return (
    <>
      <button className="toggleBtn" onClick={() => { setOpen(true); loadComments(); }}>
        Comments ({comments.length})
      </button>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={modalStyle}>
          <h3>Comments for Submission #{submissionId}</h3>
          
          {comments.length === 0 ? (
          <p style={{ color: 'gray' }}>No comments yet.</p>
        ) : (
          comments.map((c) => (
            <div className="commentItem" key={c.commentId}>
              <div className="meta">
                <b>{c.senderName}</b> · {format(new Date(c.createdAt), "dd MMM yyyy, hh:mm a")}
              </div>
              <div className="content">{c.content}</div>
              {lastComment && c.senderName === currentUsername && c.commentId === lastComment.commentId && (
                <button className="deleteBtn" onClick={() => handleDelete(c.commentId)}>🗑</button>
              )}

              <hr />
            </div>
          ))
        )}


          <div className="newComment">
            <textarea
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              placeholder="Write a comment..."
            />
            <button onClick={handleAdd}>Save</button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default CommentSection;
